import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Llegás a la clase sin saber exactamente qué figura vas a dar hoy', 'Tus alumnas no progresan porque no tenés una secuencia clara de nivel a nivel', 'El 40% de tus alumnas abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre las mismas 10 figuras de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Correcciones improvisadas, sin un método claro que te respalde', 'Alumnas de distintos niveles juntas y la clase se convierte en un caos', 'Fin de mes y las alumnas se van sin avisar porque la comunicación es inconsistente'];
export const PainPoints: React.FC = () => {
  return <section className="py-10 md:py-20 bg-primary text-white relative overflow-hidden" data-id="element-332">
      {/* Decorative background pattern and glow */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-333"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-red-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-334"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-335">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-336">
          <h2 className="text-2xl md:text-4xl font-bold font-serif mb-2 md:mb-4 drop-shadow-md" data-id="element-337">
            Si sos profe de telas en Argentina, esto te va a sonar familiar:
          </h2>
        </motion.div>

        <div className="bg-primary-dark/80 rounded-xl md:rounded-2xl p-4 md:p-8 border border-red-500/20 shadow-2xl backdrop-blur-md" data-id="element-338">
          <ul className="space-y-2 md:space-y-3" data-id="element-339">
            {painPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="flex items-center gap-3 md:gap-4 bg-red-950/30 hover:bg-red-900/40 transition-colors p-3 md:p-4 rounded-lg border border-red-500/10" data-id="element-340">
                <div className="flex items-center gap-3 flex-shrink-0" data-id="element-341">
                  <span className="text-red-500/40 font-serif font-bold text-sm md:text-base w-5 md:w-6 text-right" data-id="element-342">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <XCircle className="text-red-400 w-5 h-5 md:w-6 md:h-6" data-id="element-343" />
                </div>
                <span className="text-sm md:text-lg text-gray-100 leading-snug font-medium" data-id="element-344">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center mt-8 md:mt-14" data-id="element-345">
          <motion.h3 animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} className="text-xl md:text-3xl font-bold text-accent font-serif inline-block px-6 py-2 rounded-full bg-accent/10 border border-accent/20 shadow-[0_0_20px_rgba(76,175,80,0.2)]" data-id="element-346">
            ¿Cuántas clases más vas a improvisar?
          </motion.h3>
        </motion.div>
      </div>
    </section>;
};